import React from "react";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomeTestimonialsSection = ({ testimonials = [] }) => (
    <section
        data-testid={SITE.homeTestimonials}
        className="py-14 sm:py-20 sand-wash bg-grain"
    >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
                <p className="font-accent text-xs text-terracotta">CLIENT STORIES</p>
                <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                    Real healing, real people
                </h2>
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {testimonials.slice(0, 3).map((t) => (
                    <figure
                        key={t.id}
                        data-testid={SITE.testimonialCard}
                        className="rounded-2xl bg-white/85 border border-border/80 p-6"
                    >
                        <blockquote className="font-display text-lg text-moss leading-snug">
                            “{t.quote}”
                        </blockquote>
                        <figcaption className="mt-4 text-sm text-foreground/70">
                            <span className="font-medium text-foreground/85">{t.name}</span>{" "}
                            &bull; {t.location}
                            <br />
                            <span className="text-foreground/55">{t.treatment}</span>
                        </figcaption>
                    </figure>
                ))}
            </div>
            <div className="mt-8">
                <CtaButton to="/testimonials" variant="secondary">
                    Read more testimonials
                </CtaButton>
            </div>
        </div>
    </section>
);

export default HomeTestimonialsSection;
